export default __webpack_public_path__ + "static/media/Accessibility.904f55a6.svg";